import { useState } from 'react';
import { ValidationResult } from './types';

export const useValidation = (data?: string): ValidationResult => {
  const [hasError, setHasError] = useState<boolean>(false);
  const validate = (value: string | undefined) => {
    const isInValid = value === data;
    setHasError(isInValid);
    return !isInValid;
  };
  return { hasError, validate };
};
